import useSWR from 'swr';
import { TopPlayersFragment } from '@amf/shared/types/graphql';

function getKey(leagueId?: string, seasonId?: string, teamId?: string, limit?: number) {
  if (!teamId) return null;
  const params = new URLSearchParams({ team: teamId });
  if (leagueId && leagueId !== '-') params.append('league', leagueId);
  if (seasonId && seasonId !== '-') params.append('season', seasonId);
  if (limit) params.append('limit', String(limit));
  return `/api/team/players?${params}`;
}

function useTeamPlayers(leagueId?: string, seasonId?: string, teamId?: string, limit?: number) {
  const { data, error } = useSWR<TopPlayersFragment | null>(
    getKey(leagueId, seasonId, teamId, limit),
  );
  return {
    error,
    players: data ?? null,
    loading: !data && !error,
  };
}

export default useTeamPlayers;
